import React, { Component } from 'react';
import { components } from '@kurtosys/ksys-app-components';
import { inject, observer } from 'mobx-react';

import { InjectedStyledComponent } from '../shared/InjectedStyledComponent.js';

import AnswerPrompt from './styledComponents/AnswerPrompt.js';
import Text from './styledComponents/Text.js';
import Wrapper from './styledComponents/Wrapper.js';
import { IQuestionProps, IQuestionState } from './models';

const RadioButtons = components.base.RadioButtons.RadioButtons;

class RawQuestion extends Component<IQuestionProps, IQuestionState> {
	static configurationKey = 'question' as const;
	static styleKey = 'question' as const;
	constructor(props: IQuestionProps) {
		super(props);
	}
	render() {
		const { className, questionStore } = this.props;

		if (!questionStore) {
			return null;
		}

		const { textProps, answerPromptProps, radioButtonsProps } = questionStore;

		return (
			<Wrapper className={className}>
				<Text {...textProps} />
				<AnswerPrompt {...answerPromptProps} />
				<RadioButtons {...radioButtonsProps} />
			</Wrapper>
		);
	}
}

export const Question = inject('appStore', 'questionStore')(observer(RawQuestion));
export default InjectedStyledComponent(Question, 'question');
